import { ApplicationConfig, inject, isDevMode, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { routes } from './app.routes';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { authReducer } from './state/auth/auth.reducer';
import { AuthEffects } from './state/auth/auth.effects';
import { ConfigService } from './core/config/config.service';
import { provideServiceWorker } from '@angular/service-worker';
import { socketReducer } from './state/socket/socket.reducer';
import { SocketEffects } from './state/socket/socket.effects';
import { appReducer } from './state/app/app.reducer';
import { localStorageSyncReducer } from './state/auth/auth.metareducer';
import { provideAnimations } from '@angular/platform-browser/animations'
import { hotelInformationReducer } from './state/hotel-information/hotel-information.reducer';
import { HotelInformationEffects } from './state/hotel-information/hotel-information.effects';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([authTokenInterceptor])
    ),
    provideStore({
      app: appReducer,
      auth: authReducer,
      socket: socketReducer,
      hotelInformation: hotelInformationReducer,
    },{
      metaReducers: [localStorageSyncReducer],
    }),
    provideEffects([AuthEffects, SocketEffects, HotelInformationEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    provideAppInitializer(() => inject(ConfigService).load()), 
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideAnimations(),
  ],
};

